import React, { createContext, useContext, useEffect, useState } from 'react';
import apiHandler from '../handlers/ApiHandler';

// First-party A/B testing. The server owns which experiments are live, their
// variants and weights — we only fetch the active list once and hold it. On
// error (or before the request resolves) the list is empty, so every call to
// `useExperiment` yields no assignment and callers fall back to default copy.
// Nothing here ever throws or blocks render.
const ExperimentContext = createContext({ experiments: [], loading: true });

export const ExperimentProvider = ({ children }) => {
  const [experiments, setExperiments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    apiHandler
      .get('/experiments/active')
      .then((response) => {
        if (!mounted) return;
        const list =
          response && Array.isArray(response.experiments) ? response.experiments : [];
        setExperiments(list);
      })
      .catch(() => {
        if (mounted) setExperiments([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  const value = { experiments, loading };

  return (
    <ExperimentContext.Provider value={value}>{children}</ExperimentContext.Provider>
  );
};

export const useExperiments = () => useContext(ExperimentContext);

export default ExperimentContext;
